module.exports = __webpack_public_path__ + "static/media/icon_search_blue.dc0f7f10.svg";